export namespace GasCard {
  export enum SpacingType {
    None = 'null',
    Default = 'default',
    Maxi = 'maxi',
    Small = 'small',
    Info = 'info',
    Actions = 'actions',
  }

  export enum ButtonType {
    Default = 'default',
    Brand = 'brand',
    Positive = 'positive',
    Destructive = 'destructive',
  }
}
